import {lazy} from 'react';

export const ApiBoxesLazy = lazy(() => import(/* webpackChunkName: "ApiBoxes" */ '.'));
